import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "flex-1 highlight" }
const _hoisted_3 = { class: "flex-1 align-right" }

import { reactive } from 'vue';
import vueSeamlessScroll from "vue-seamless-scroll/src";
import { useWindowSize } from '@vant/use';


export default {
  __name: 'SpinLog',
  props: ['logList'],
  setup(__props) {

const props = __props

const { width, height } = useWindowSize();
const classOption = reactive({
  singleHeight: Math.round(23 / 430 * width.value),
  openTouch: false,
  waitTime: 3000
})



return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(vueSeamlessScroll), {
    data: __props.logList,
    "class-option": classOption,
    class: "spin-log-wrap"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.logList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "spin-log-item flex",
            key: index
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(item.username), 1),
            _createElementVNode("div", _hoisted_2, "P" + _toDisplayString(_ctx.$filter.outputAmount(item.amount)), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$moment(item.createTime * 1000).format('HH:mm:ss')), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["data", "class-option"]))
}
}

}